import React, { useEffect, useState } from "react";
import instanceCommerce from "../../../config/instanceCommerce";
import useTrackWebContext from "../../../hooks/useTrackWebContext";

const BranchSelect = ({ onSelectBranch, branch }) => {
  const { infoCommerce, dataCommerce, token } = useTrackWebContext();
  const userRole = infoCommerce?.rol;

  const [branches, setBranches] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (userRole === "marca" && dataCommerce && token) {
        try {
          const res = await instanceCommerce({
            url: `/api/GetSucursalesByMarca?nro_comercio=${dataCommerce}`,
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
            },
          });
          setBranches(res.data.sucursales);
          
        } catch (error) {
          console.error("Error al obtener sucursales:", error);
        }
      }
    };
    fetchData();
  }, [userRole, dataCommerce, token]);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      const branchData = JSON.parse(selectedValue);
      onSelectBranch(branchData); 
    } else {
      onSelectBranch(null);
    }
  };

  return (
    <div className="w-full">
      <select
        id="branch"
        value={branch ? JSON.stringify(branch) : ""}
        onChange={handleChange}
        className="mt-1 block w-1/2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
      >
        <option value="">Selecciona una sucursal</option>
        {branches?.length > 0 ? (
          branches.map((branch) => (
            <option
              key={branch.id_sucursal}
              value={JSON.stringify({
                id_sucursal: branch.id_sucursal,
                nombre_sucursal: branch.nombre_sucursal,
              })}
            >
              {branch.nombre_sucursal}
            </option>
          ))
        ) : (
          <option value="" disabled>
            No branches available
          </option>
        )}
      </select>
    </div>
  );
};

export default BranchSelect;
